// React core imports
import React, { useEffect, useState } from "react";

// UI component library imports
import { TextField } from "@material-ui/core";
import PuffLoader from "react-spinners/PuffLoader";

// Styling helper
import { css } from "@emotion/react";

// Routing imports
import { Link } from "react-router-dom";

// Redux imports
import { useDispatch, useSelector } from "react-redux";

// Utilities and custom hooks
import GA from "../functions/GA";
import useScapePressed from "../../functions/useScapePressed";
import selectCorrectUrls from "../../selectCorrectUrls";

// HTTP client for API calls
import Axios from "axios";

// Device detection utility
import { isMobile } from "react-device-detect";

// Custom components
import PaymentIdCardModal from "../policyHolderPortal/PaymentIdCardModal";

// Stylesheets
import "../header/Header.css";

const CustomerLogin = ({ display }) => {
  // Custom hooks
  const scapePressed = useScapePressed();
  const dispatch = useDispatch();

  // Modal visibility states
  const [modalShow, setModalShow] = useState(false);
  const [isMenuOpened, setIsMenuOpened] = useState(false);

  // Loading and disabled flags
  const [isLoading, setIsLoading] = useState(false);
  const [isAgentDisabled, setAgentDisabled] = useState(true);
  const [isCustomerDisabled, setCustomerDisabled] = useState(true);

  // Responsive UI flag
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  // Login roles and selections
  const [selectedRole, setSelectedRole] = useState("agent");
  const [selectedRadioButtonCustomer, setSelectedRadioButtonCustomer] =
    useState("insured_login");

  // User credentials state
  const [customerUsername, setCustomerUsername] = useState("");
  const [customerPassword, setCustomerPassword] = useState("");

  // Message and error handling states
  const [message, setMessage] = useState("");
  const [isMessage, setIsMessage] = useState(false);
  const [failed, setFailed] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [isconfirmLoginMessage, setIsConfirmLoginMessage] = useState(false);
  const [weather_message_html, set_weather_message_html] =
    useState(`<p>Hello there</p>`);

  // Forgot password states and timers for Agent and Customer
  const [isForgotPasswordAgent, setIsForgotPasswordAgent] = useState(false);
  const [forgotPasswordAgent, setForgotPasswordAgent] = useState("");
  const [forgotPasswordTimerSecondsAgent, setForgotPasswordTimerSecondsAgent] =
    useState(120);
  const [isForgotPasswordTimerAgent, setIsForgotPasswordTimerAgent] =
    useState(false);

  const [isForgotPasswordCustomer, setIsForgotPasswordCustomer] =
    useState(false);
  const [forgotPasswordCustomer, setForgotPasswordCustomer] = useState("");
  const [
    forgotPasswordTimerSecondsCustomer,
    setForgotPasswordTimerSecondsCustomer,
  ] = useState(120);
  const [isForgotPasswordTimerCustomer, setIsForgotPasswordTimerCustomer] =
    useState(false);

  // Form validation errors for customer
  const [errorsCustomer, setErrorsCustomer] = useState({
    username: false,
    password: false,
  });

  // Correct field names and IDs (Agent and Customer) - for accessibility or form control
  const [correctNamesAndIds, setCorrectNamesAndIds] = useState({
    username: "",
    password: "",
    nameUserId: "",
    namePassword: "",
  });
  const [correctNamesAndIdsCustomer, setCorrectNamesAndIdsCustomer] = useState({
    username: "",
    password: "",
    nameUserId: "",
    namePassword: "",
  });

  // Redux selectors for menu states
  const isLoginMenuOpen = useSelector((state) => state.isLoginMenuOpenReducer);
  const selectedLogintoDisplayReducer = useSelector(
    (state) => state.selectedLogintoDisplayReducer
  );
  const isAgentsLoginMenuOpen = useSelector(
    (state) => state.isAgentsLoginMenuOpenReducer
  );
  const isCustomerLoginMenuOpen = useSelector(
    (state) => state.isCustomerLoginMenuOpenReducer
  );

  // Configuration for API calls or content type
  const [config, setConfig] = useState({
    headers: {
      "Content-Type": "text/html",
    },
    responseType: "text",
  });

  // Helper function to reset form field name/id states
  const resetState = (setStateFn) => {
    setStateFn({
      username: "",
      password: "",
      nameUserId: "",
      namePassword: "",
    });
  };

  // Function to close login menu and reset messages, dispatches Redux actions depending on current menu open state
  const closeLoginMenu = () => {
    set_weather_message_html(`<p>Hello there</p>`);
    setIsConfirmLoginMessage(false);
    if (isLoginMenuOpen) {
      dispatch({ type: "OPEN_LOGIN_MENU" });
    } else if (isAgentsLoginMenuOpen) {
      dispatch({ type: "OPEN_AGENTS_LOGIN_MENU" });
    } else if (isCustomerLoginMenuOpen) {
      dispatch({ type: "OPEN_CUSTOMER_LOGIN_MENU" });
    }
  };

  useEffect(() => {
    if (isForgotPasswordCustomer) {
      setIsForgotPasswordCustomer(false);
    }
  }, [scapePressed]);

  const checkDisabledButtonCustomer = () => {
    if (isCustomerDisabled) {
      return "home-page-button-off";
    } else return "home-page-button";
  };

  const override = css`
    display: flex;
    margin: auto;
    color: white;
    margin-top: -7px;
  `;

  const selectCorrectActionForCustomers = () => {
    if (isMobile) {
      if (selectedRadioButtonCustomer === "insured_login") {
        return `${selectCorrectUrls().insuredPortal}/mobile/login`;
      } else if (selectedRadioButtonCustomer === "claims_login") {
        return `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/claimuser/clogin`;
      }
    } else {
      if (selectedRadioButtonCustomer === "insured_login") {
        return `${selectCorrectUrls().insuredPortal}/insurednew/login`;
      } else if (selectedRadioButtonCustomer === "claims_login") {
        return `${
          selectCorrectUrls().insuredPortal
        }/insurednew/insured/claimuser/clogin`;
      }
    }
  };
  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  const guestPaymentSection = () => {
    return (
      <>
        <span style={{ fontSize: "14px" }}>Don't have an account? - </span>
        <br className="MOBILE-ONLY" />
        <span
          onClick={() => {
            setModalShow(true);
            dispatch({
              type: "SET_GUEST_OPT",
              payload: "Payment",
            });
          }}
          className=""
          style={{
            cursor: "pointer",
            fontSize: "14px",
            color: "#0E72D6",
          }}
        >
          {" "}
          Make Payment
        </span>
        {" / "}
        <span
          className=""
          style={{
            cursor: "pointer",
            fontSize: "14px",
            color: "#0E72D6",
          }}
          onClick={() => {
            setModalShow(true);
            dispatch({
              type: "SET_GUEST_OPT",
              payload: "ID",
            });
          }}
        >
          Get ID Card
        </span>
      </>
    );
  };

  const guestPaymentSectionTemporary = () => {
    return (
      <span style={{ fontSize: "14px", textAlign: "center" }}>
        Don't have an account -
        <a href={`${selectCorrectUrls().insuredPortal}`}>
          <span
            className=""
            style={{
              cursor: "pointer",
              fontSize: "14px",
              color: "#0E72D6",
            }}
          >
            {" "}
            Click to make payment or <br className="DESKTOP-ONLY" /> Get Id
            Card.
          </span>
        </a>
      </span>
    );
  };

  const customerValidPost = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const newErrors = {
      username: customerUsername.trim() === "",
      password: customerPassword.trim() === "",
    };
    setErrorsCustomer(newErrors);

    if (!newErrors.username && !newErrors.password) {
      let url = `${
        selectCorrectUrls().insuredPortal
      }/insurednew/insured/logincheck/customer?username=${customerUsername}&password=${encodeURIComponent(
        customerPassword
      )}`;

      Axios.get(url, config)
        .then((response) => {
          setIsLoading(false);
          let data = response.data.replace(/^\s+|\s+$/g, "");
          // console.log(response);
          if (data === "OK") {
            // GA(
            //   "CUSTOMER_LOGIN_SUCCESSFUL",
            //   `${customerUsername} - Successfully logged in Insured Portal`
            // );
            setIsLoading(false);
            setFailed(false);

            setIsMessage(true);
            setMessage("You have Successfully Logged In");
            setCorrectNamesAndIdsCustomer({
              username: "username",
              password: "password",
              nameUserId: "username",
              namePassword: "password",
            });

            document.getElementById("mainFormCustomer").submit();
            return true;
          } else {
            GA(
              "CUSTOMER_LOGIN_FAILED",
              `${customerUsername} -  Failed while trying to log into the Insured Portal`
            );

            setIsErrorMessage(true);
            setFailed(true);
            setMessage(data);
            return false;
          }
        })
        .catch((e) => {
          setIsLoading(false);
          GA(
            "CUSTOMER_SYSTEM_FAILURE",
            `${customerUsername} -  System failure while trying to log into the Insured Portatl`
          );
          setFailed(true);
          // setIsErrorMessage(true);
          setMessage("System Failure: Please try after some time.");

          // console.log(e);
        });
    }
  };
  const [showModal, setShowModal] = useState(false);

  const forgotPasswordComponentCustomer = () => {
    return (
      <div>
        <div
          onClick={() => {
            setIsForgotPasswordAgent(false);
            setIsForgotPasswordCustomer(false);
          }}
          className={
            isForgotPasswordCustomer
              ? "forgot-password-background-on"
              : "forgot-password-background-off"
          }
        ></div>
        <div
          className={
            isForgotPasswordCustomer
              ? "forgot-password-component-shown"
              : "forgot-password-component-hidden"
          }
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h2>Forgot your password?</h2>
            <h2
              className="close-login-menu-icon"
              onClick={() => {
                setIsForgotPasswordCustomer(false);
                setIsForgotPasswordAgent(false);
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{ fontSize: "1.5em", color: "#01224f" }}
                aria-hidden="true"
              ></i>{" "}
              &nbsp;
            </h2>
          </div>

          <hr></hr>
          <form
            onSubmit={(e) => {
              sendForgotPasswordEmail(e, "customer");
            }}
          >
            <div style={{ marginTop: "1rem" }}>
              <TextField
                placeholder="Email"
                label="Enter your Email"
                variant="outlined"
                autoFocus
                required
                fullWidth
                value={forgotPasswordCustomer}
                onChange={(e) => {
                  setForgotPasswordCustomer(e.target.value);
                }}
                style={{ marginTop: "12px" }}
              />
            </div>
            <button
              disabled={isForgotPasswordTimerCustomer}
              type="submit"
              style={
                isForgotPasswordTimerCustomer
                  ? {
                      backgroundColor: "rgba(220,220,220)",
                      marginTop: "10px",
                      cursor: "default",
                      pointerEvents: "none",
                      color: "black",
                    }
                  : { marginTop: "10px" }
              }
              className="home-page-button"
            >
              {/* {isForgotPasswordTimerCustomer
                  ? forgotPasswordTimerSecondsCustomer
                  : "Submit"} */}
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  };

  const sendForgotPasswordEmail = (e, where) => {
    e.preventDefault();
    setIsLoading(true);

    setIsForgotPasswordAgent(false);
    setIsForgotPasswordCustomer(false);

    //this is a test url, once we have the correct service we can send emails to the email that the user typed

    let url = "";

    if (where === "agent") {
      url = `${
        selectCorrectUrls().insuredPortal
      }/uaicins/agent/forgotpassword/index?agentid=${forgotPasswordAgent}`;

      Axios.get(url, config)
        .then((response) => {
          setIsLoading(false);

          if (response.data.status === 1 || response.data.status === "1") {
            setIsMessage(true);
            setIsLoading(false);
            resetState(setCorrectNamesAndIds);
            setForgotPasswordAgent("");
            setMessage(response.data.msg);
            GA(
              "FORGOT_PASSWORD_AGENT",
              `${forgotPasswordAgent} - Successfully requested to change password`
            );

            setForgotPasswordTimerSecondsAgent(120);
            setIsForgotPasswordTimerAgent(true);
          } else if (response.data.status == 0) {
            GA(
              "FORGOT_PASSWORD_AGENT_FAILED",
              `${forgotPasswordAgent} - Failed to request to change password`
            );
            setForgotPasswordAgent("");
            setIsLoading(false);
            setFailed(true);
            setIsErrorMessage(true);
            setMessage(response.data.msg);
          }
        })
        .catch((e) => {
          setIsLoading(false);
          setFailed(true);
          setForgotPasswordAgent("");
          console.log(e);
          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);
          setIsErrorMessage(true);
          setMessage("Something went wrong, try again later.");
        });
    } else if (where === "customer") {
      url = `${
        selectCorrectUrls().insuredPortal
      }/insurednew/insured/pms/fp?email-id=${forgotPasswordCustomer}`;

      Axios.get(url)
        .then((response) => {
          setIsLoading(true);

          // console.log(response);

          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);

          if (response.data.status == 1 || response.data.status == "1") {
            resetState(setCorrectNamesAndIdsCustomer);
            setIsMessage(true);
            setForgotPasswordCustomer("");

            setIsLoading(false);
            setFailed(false);
            setMessage(response.data.displaymsg);
            // setMessage(
            //   "If a valid email is found we would be sending instructions to reset password in the email."
            // );
            GA(
              "FORGOT_PASSWORD_CUSTOMER",
              `${forgotPasswordCustomer} - Successfully requested to change password`
            );

            setForgotPasswordTimerSecondsAgent(120);
            setIsForgotPasswordTimerAgent(true);
          } else if (
            response.data.status === 0 ||
            response.data.status === "0"
          ) {
            GA(
              "FORGOT_PASSWORD_CUSTOMER_FAILED",
              `${forgotPasswordCustomer} - Failed to request to change password`
            );

            setIsMessage(true);
            setIsLoading(false);
            setMessage(response.data.displaymsg);
            setForgotPasswordTimerSecondsCustomer(120);
            setIsForgotPasswordTimerCustomer(true);
          }
        })
        .catch((e) => {
          setIsLoading(false);

          console.log(e);
          setIsForgotPasswordAgent(false);
          setIsForgotPasswordCustomer(false);
          setIsErrorMessage(true);
          setMessage("Something went wrong, try again later.");
        });
    }
  };
  const checkDisabledButtonAgent = () => {
    if (isAgentDisabled) {
      return "home-page-button-off";
    } else return "home-page-button";
  };

  const handleChange = (event) => {
    setSelectedRole(event.target.value);
  };
  const getInputClass = (value, error) => {
    if (error) return "form-control border-danger";
    if (value.trim() !== "") {
      return failed
        ? "form-control border-danger"
        : "form-control border-success";
    }
    return "form-control";
  };

  return (
    <>
      <form
        action={selectCorrectActionForCustomers()}
        name="mainFormCustomer"
        id="mainFormCustomer"
        method="POST"
      >
        {message !== "" ? (
          <p
            style={{
              color: failed ? "red" : "green",
              fontWeight: "bold",
              textAlign: "center",
              width: "100%",
            }}
          >
            {message}
          </p>
        ) : (
          ""
        )}
        {display === "popup" ? (
          <div className="mb-1" style={{ display: "flex", gap: "20px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                color: "#17252E",
                lineHeight: "140%",
                fontSize: "11px",
                fontWeight: 600,
              }}
            >
              <input
                type="radio"
                value="agent"
                checked={selectedRole === "agent"}
                onChange={handleChange}
              />
              For Policy
            </label>

            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                color: "#17252E",
                lineHeight: "140%",
                fontSize: "11px",
                fontWeight: 600,
              }}
            >
              <input
                type="radio"
                value="customer"
                checked={selectedRole === "customer"}
                onChange={handleChange}
              />
              For Claims
            </label>
          </div>
        ) : (
          ""
        )}
        <div className="mb-3">
          {display === "page" ? (
            <label className="form-label">
              <span className="text-danger">*</span> Email Address
            </label>
          ) : (
            ""
          )}
          <input
            style={{ fontSize: "11px", color: "#A09999" }}
            type="text"
            className={getInputClass(customerUsername, errorsCustomer.username)}
            value={customerUsername}
            name={correctNamesAndIdsCustomer.nameUserId}
            placeholder="Username"
            onChange={(e) => {
              setCustomerUsername(e.target.value);
            }}
          />
        </div>
        <div className="mb-3">
          {display === "page" ? (
            <label className="form-label">
              <span className="text-danger">*</span> Password
            </label>
          ) : (
            ""
          )}
          <input
            style={{ fontSize: "11px", color: "#A09999" }}
            type="password"
            value={customerPassword}
            className={getInputClass(customerPassword, errorsCustomer.password)}
            name={correctNamesAndIdsCustomer.namePassword}
            onChange={(e) => {
              setCustomerPassword(e.target.value);
            }}
            placeholder="Password"
          />
        </div>

        <button
          onClick={(e) => {
            customerValidPost(e);
            GA(
              "Log_In ",
              "User clicked on the customers login button inside pop up"
            );
          }}
          className={`btn btn-mobile-primary-login ${checkDisabledButtonCustomer(
            isCustomerDisabled
          )}`}
          type="submit"
          disabled={!customerUsername || !customerPassword}
        >
          {isLoading ? (
            <div>
              <PuffLoader color={"white"} css={override} size={30} />
            </div>
          ) : (
            "Login"
          )}
        </button>
        <div className="text-center mt-3">
          <span
            onClick={() => {
              setIsForgotPasswordCustomer(true);
            }}
            // className="d-block mb-1 "
            className="text-primary text-decoration-none"
            style={{
              cursor: "pointer",
              fontSize: "14px",
              color: "#0E72D6",
            }}
          >
            Reset Password
          </span>
          {selectedLogintoDisplayReducer === "CUSTOMER" &&
          selectedRole === "agent" ? (
            <>
              <br />
              <Link
                to="/uaichome/newuser/customer"
                className="text-primary text-decoration-none"
                style={{
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#0E72D6",
                  marginTop: "0.25em",
                }}
                onClick={() => {
                  closeLoginMenu();
                }}
              >
                Create an Account
              </Link>
            </>
          ) : (
            <>
              <br />
              <Link
                to="/uaichome/newuser/customer"
                className="text-primary text-decoration-none"
                style={{
                  cursor: "pointer",
                  fontSize: "14px",
                  color: "#0E72D6",
                  marginTop: "0.25em",
                }}
                onClick={() => {
                  closeLoginMenu();
                }}
              >
                Create an Account
              </Link>{" "}
            </>
          )}
          <span className="d-block ">
            {selectedRole === "customer" ? (
              <span style={{ fontSize: "14px" }}>
                Don’t Have An Account? -
                <a
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#0E72D6",
                  }}
                  href="https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims"
                >
                  Click here to continue
                </a>
              </span>
            ) : (
              <> {guestPaymentSection()}</>
              // <> {guestPaymentSectionTemporary()}</>
            )}
          </span>
          {modalShow}
        </div>
      </form>
      {!responsiveStatus && isForgotPasswordCustomer && (
        <>
          <div
            className="modal show fade d-block second-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "7px",
              }}
            >
              <div
                className="modal-content"
                style={{ width: `${responsiveStatus ? "auto" : "auto"}` }}
              >
                <div className="modal-header" style={{ marginBottom: "0" }}>
                  <h5 className="modal-title">Forgot Password</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsForgotPasswordCustomer(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <div
                    className="modal-dialog modal-sm modal-dialog-centered"
                    role="document"
                  >
                    <div
                      className="modal-content d-flex flex-row p-1"
                      style={{ border: "none" }}
                    >
                      <form
                        style={{ width: "100%" }}
                        onSubmit={(e) => sendForgotPasswordEmail(e, "customer")}
                      >
                        <input
                          type="text"
                          placeholder="Email"
                          value={forgotPasswordCustomer}
                          onChange={(e) =>
                            setForgotPasswordCustomer(e.target.value)
                          }
                          className="form-control mb-3"
                          required
                          autoFocus
                        />

                        <button
                          style={{
                            width: "100%",
                            backgroundColor: "#0E72D6",
                            color: "#FFF",
                            border: "1px solid",
                            padding: "10px",
                          }}
                          onClick={(e) => {
                            sendForgotPasswordEmail(e, "customer");
                          }}
                          disabled={isForgotPasswordTimerCustomer}
                          className={checkDisabledButtonAgent(isAgentDisabled)}
                          type="submit"
                        >
                          {isForgotPasswordTimerCustomer
                            ? forgotPasswordTimerSecondsCustomer
                            : "Submit"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      {responsiveStatus && isForgotPasswordCustomer && (
        <>
          <div
            className="modal show fade d-block second-modal"
            tabIndex="-1"
            role="dialog"
          >
            <div
              className="modal-dialog modal-dialog-centered"
              role="document"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div className="modal-content" style={{ width: `70%` }}>
                <div className="modal-header" style={{ marginBottom: "0" }}>
                  <h5 className="modal-title">Forgot Password</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setIsForgotPasswordCustomer(false);
                      setShowModal(true);
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div
                    className="modal-dialog modal-sm modal-dialog-centered"
                    role="document"
                    style={{ marginTop: "7px" }}
                  >
                    <div
                      className="modal-content d-flex flex-row p-1"
                      style={{ border: "none" }}
                    >
                      <form
                        style={{ width: "100%" }}
                        onSubmit={(e) => sendForgotPasswordEmail(e, "customer")}
                      >
                        <input
                          type="text"
                          placeholder="Email"
                          value={forgotPasswordCustomer}
                          onChange={(e) =>
                            setForgotPasswordCustomer(e.target.value)
                          }
                          className="form-control mb-3"
                          required
                          autoFocus
                        />

                        <button
                          style={{
                            width: "100%",
                            backgroundColor: "#0E72D6",
                            color: "#FFF",
                            border: "1px solid",
                            padding: "10px",
                          }}
                          onClick={(e) => {
                            sendForgotPasswordEmail(e, "customer");
                          }}
                          disabled={isForgotPasswordTimerCustomer}
                          className={checkDisabledButtonAgent(isAgentDisabled)}
                          type="submit"
                        >
                          {/* {isForgotPasswordTimerCustomer
                            ? forgotPasswordTimerSecondsCustomer
                            : "Submit"} */}
                          Submit
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
      <PaymentIdCardModal
        isOpen={modalShow}
        onClose={() => setModalShow(false)}
      />
    </>
  );
};

export default CustomerLogin;
